const List = () => import("@/pages/master/permission/List")
const Form = () => import("@/pages/master/permission/Form")
// import List from '@/pages/master/permission/List'
// import Form from '@/pages/master/permission/Form'
import layout from "@/layout/Master"

const data = [
  {
    path: "/master/permission",
    name: "permission-list",
    components: {
      content: List,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Permission" },
        { title: "List", active: true }
      ],
      title: "Permission List",
      module: "Permission",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/permission/create",
    name: "permission-create",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Permission" },
        { title: "Create", active: true }
      ],
      title: "Permission Create",
      module: "Permission",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/permission/view/:id",
    name: "permission-view",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Permission" },
        { title: "View", active: true }
      ],
      title: "Permission View",
      module: "Permission",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/permission/edit/:id",
    name: "permission-edit",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Permission" },
        { title: "Edit", active: true }
      ],
      title: "Permission Edit",
      module: "Permission",
      showLink: false,
      requiresAuth: true
    }
  }
]
export default data
